// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.S2clsoghHKVXx4hxXuTI {
	align-items: center;
	display: flex;
	padding: 12px 0;
}

.jHLe82IZHw0Q76nz5dIA {
	display: flex;
	align-items: center;
	flex: 1;
}

.GwYumoKWsnyss5QpwgbV {
	cursor: default;
	font-size: 12px;
	letter-spacing: -0.05em;
	line-height: 12px;
	margin-left: 2px;
}

.kuKD4iVQLAsiIu2_qLUh {
	color: var(--black);
	font-size: 16px;
	letter-spacing: -0.08em;
	line-height: 24px;
	opacity: 0.3;
}

.snYZo5ok0FYrezGXA5bu {
	align-items: center;
	display: flex;
}

.HwxS5icLUKRlQ75rn7Iu {
	display: flex;
	gap: 8px;
}

.HwxS5icLUKRlQ75rn7Iu > * {
		animation: M2URopx0h08mHo6_yM8V 1s linear infinite;
		opacity: 0.3;
	}

.GWmGQ1X_IsPB0DpOWmoa {
	background: rgba(0, 0, 0, 0.72);
	box-shadow: 0px 30.78px 24.42px -15px rgba(0, 0, 0, 0.1203),
		0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275),
		0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035),
		0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725),
		0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
	backdrop-filter: blur(24px);
	border-radius: 8px;
	max-width: 400px;
}

.lt99it9Nnwdtqe4Xy0Xw {
	color: var(--white);
	font-size: 12px;
	letter-spacing: -0.05em;
	line-height: 16px;
}

@keyframes M2URopx0h08mHo6_yM8V {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/AboutLockInfo/AboutLockInfo.pcss"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,OAAO;AACR;;AAEA;CACC,eAAe;CACf,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,aAAa;CACb,QAAQ;AAMT;;AAJC;EACC,kDAAkC;EAClC,YAAY;CACb;;AAGD;CACC,+BAA+B;CAC/B;;;;kDAIiD;CACjD,2BAA2B;CAC3B,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC;EACC,uBAAuB;CACxB;CACA;EACC,yBAAyB;CAC1B;AACD","sourcesContent":[".container {\n\talign-items: center;\n\tdisplay: flex;\n\tpadding: 12px 0;\n}\n\n.label {\n\tdisplay: flex;\n\talign-items: center;\n\tflex: 1;\n}\n\n.question {\n\tcursor: default;\n\tfont-size: 12px;\n\tletter-spacing: -0.05em;\n\tline-height: 12px;\n\tmargin-left: 2px;\n}\n\n.labelText {\n\tcolor: var(--black);\n\tfont-size: 16px;\n\tletter-spacing: -0.08em;\n\tline-height: 24px;\n\topacity: 0.3;\n}\n\n.value {\n\talign-items: center;\n\tdisplay: flex;\n}\n\n.placeholder {\n\tdisplay: flex;\n\tgap: 8px;\n\n\t& > * {\n\t\tanimation: spin 1s linear infinite;\n\t\topacity: 0.3;\n\t}\n}\n\n.tooltip {\n\tbackground: rgba(0, 0, 0, 0.72);\n\tbox-shadow: 0px 30.78px 24.42px -15px rgba(0, 0, 0, 0.1203),\n\t\t0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275),\n\t\t0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035),\n\t\t0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725),\n\t\t0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);\n\tbackdrop-filter: blur(24px);\n\tborder-radius: 8px;\n\tmax-width: 400px;\n}\n\n.hint {\n\tcolor: var(--white);\n\tfont-size: 12px;\n\tletter-spacing: -0.05em;\n\tline-height: 16px;\n}\n\n@keyframes spin {\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\t100% {\n\t\ttransform: rotate(360deg);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `S2clsoghHKVXx4hxXuTI`,
	"label": `jHLe82IZHw0Q76nz5dIA`,
	"question": `GwYumoKWsnyss5QpwgbV`,
	"labelText": `kuKD4iVQLAsiIu2_qLUh`,
	"value": `snYZo5ok0FYrezGXA5bu`,
	"placeholder": `HwxS5icLUKRlQ75rn7Iu`,
	"spin": `M2URopx0h08mHo6_yM8V`,
	"tooltip": `GWmGQ1X_IsPB0DpOWmoa`,
	"hint": `lt99it9Nnwdtqe4Xy0Xw`
};
export default ___CSS_LOADER_EXPORT___;
